var map = {
	"./Server-Busy.None.svg": 2836,
	"./Server-Busy.OfflineDrop.svg": 2837,
	"./Server-Busy.Ssh.svg": 2838,
	"./Server-Busy.TentacleActive.svg": 2839,
	"./Server-Busy.TentaclePassive.svg": 2840,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2841,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2842,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2843,
	"./Server-Default.AzureCloudService.svg": 2844,
	"./Server-Default.AzureServiceFabricCluster.svg": 2845,
	"./Server-Default.AzureSubscription.svg": 2846,
	"./Server-Default.AzureWebApp.svg": 2847,
	"./Server-Default.Kubernetes.svg": 2848,
	"./Server-Default.None.svg": 2849,
	"./Server-Default.OfflineDrop.svg": 2850,
	"./Server-Default.Ssh.svg": 2851,
	"./Server-Default.TentacleActive.svg": 2852,
	"./Server-Default.TentaclePassive.svg": 2853,
	"./Server-Disabled.AzureCloudService.svg": 2854,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2855,
	"./Server-Disabled.AzureSubscription.svg": 2856,
	"./Server-Disabled.AzureWebApp.svg": 2857,
	"./Server-Disabled.Kubernetes.svg": 2858,
	"./Server-Disabled.None.svg": 2859,
	"./Server-Disabled.OfflineDrop.svg": 2860,
	"./Server-Disabled.Ssh.svg": 2861,
	"./Server-Disabled.TentacleActive.svg": 2862,
	"./Server-Disabled.TentaclePassive.svg": 2863,
	"./Server-HasWarnings.Ssh.svg": 2864,
	"./Server-HasWarnings.TentacleActive.svg": 2865,
	"./Server-HasWarnings.TentaclePassive.svg": 2866,
	"./Server-Healthy.AzureCloudService.svg": 2867,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 2868,
	"./Server-Healthy.AzureSubscription.svg": 2869,
	"./Server-Healthy.AzureWebApp.svg": 2870,
	"./Server-Healthy.Kubernetes.svg": 2871,
	"./Server-Healthy.None.svg": 2872,
	"./Server-Healthy.OfflineDrop.svg": 2873,
	"./Server-Healthy.Ssh.svg": 2874,
	"./Server-Healthy.TentacleActive.svg": 2875,
	"./Server-Healthy.TentaclePassive.svg": 2876,
	"./Server-NeedsUpgrade.TentacleActive.svg": 2877,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 2878,
	"./Server-Unavailable.AzureCloudService.svg": 2879,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 2880,
	"./Server-Unavailable.AzureSubscription.svg": 2881,
	"./Server-Unavailable.AzureWebApp.svg": 2882,
	"./Server-Unavailable.Kubernetes.svg": 2883,
	"./Server-Unavailable.OfflineDrop.svg": 2884,
	"./Server-Unavailable.Ssh.svg": 2885,
	"./Server-Unavailable.TentacleActive.svg": 2886,
	"./Server-Unavailable.TentaclePassive.svg": 2887,
	"./Server-Unhealthy.AzureCloudService.svg": 2888,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 2889,
	"./Server-Unhealthy.AzureWebApp.svg": 2890,
	"./Server-Unhealthy.Kubernetes.svg": 2891,
	"./Server-Unhealthy.OfflineDrop.svg": 2892,
	"./Server-Unhealthy.Ssh.svg": 2893,
	"./Server-Unhealthy.TentacleActive.svg": 2894,
	"./Server-Unhealthy.TentaclePassive.svg": 2895,
	"./Server-Unknown.AzureCloudService.svg": 2896,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 2897,
	"./Server-Unknown.AzureSubscription.svg": 2898,
	"./Server-Unknown.AzureWebApp.svg": 2899,
	"./Server-Unknown.Kubernetes.svg": 2900,
	"./Server-Unknown.None.svg": 2901,
	"./Server-Unknown.OfflineDrop.svg": 2902,
	"./Server-Unknown.Ssh.svg": 2903,
	"./Server-Unknown.TentacleActive.svg": 2904,
	"./Server-Unknown.TentaclePassive.svg": 2905,
	"./Server-Warning.OfflineDrop.svg": 2906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2835;